export enum AnswerType {
    /**
     * 纯文本
     */
    PureText = 0,
    /**
     * 富文本
     */
    RichText = 1,
    /**
     * 单图片
     */
    SinglePic = 2,
    /**
     * 图文页面
     */
    PictAndText = 3,
    /**
     * 音频
     */
    Audio = 4,
    /**
     * 视频
     */
    Video = 5,
    /**
     * 附件
     */
    Attachment = 6,
    /**
     * 关联问
     */
    LinkAnswer = 'L01',
    /**
     * 通用回复
     */
    Common = 'C01'
}

export enum MsgType {
    /**
     * 时间
     */
    Time = 'Time',
    /**
     * 提示
     */
    Tip = 'Tip',
    /**
     * 欢迎语
     */
    Welcome = 'Welcome',
    /**
     * 热门推荐
     */
    HotList = 'HotList',
    /**
     * 拒识转人工
     */
    RejectManual = 'RejectManual',
    /**
     * 沉默超时意图
     */
    Silence = 'Silence',
    /**
     * 结束
     */
    End = 'End',
    /**
     * 机器人回答
     */
    RobotMsg = 'RobotMsg',
    /**
     * 用户消息
     */
    UserMsg = 'UserMsg',
    /**
     * 用户发送图片
     */
    UserImg = 'UserImg',
    /**
     * 用户语音
     */
    UserVoice = 'UserVoice',
    /**
     * 人工回答
     */
    HumanMsg = 'HumanMsg',
    /**
     * 人工发送的图片
     */
    HumanImg = 'HumanImg',
    /**
     * 人工满意度评价
     */
    SatisFaction = 'SatisFaction'
}

export enum FeedStatus {
    /**
     * 满意，已解决
     */
    Solved = 1,
    /**
     * 不满意，未解决
     */
    Unsolved = -1
}

export enum ChatStatus {
    /**
     * 会话没有初始化
     */
    NotInit = 'NotInit',
    /**
     * 会话已初始化
     */
    Inited = 'Inited',
    /**
     * 会话结束
     */
    Ended = 'Ended'
}

export const emojiList = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡',
  '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷',
  '冷汗', '抓狂', '吐', '偷笑', '可爱', '白眼', '傲慢', '饥饿',
  '困', '惊恐', '流汗', '憨笑', '大兵', '奋斗', '咒骂', '疑问',
  '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗',
  '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视',
  '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜',
  '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢',
  '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球',
  '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱',
  '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO',
  'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头',
  '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']

export const emojiListEnglist = ['Smile', 'Grimace', 'Drool', 'Scowl', 'CoolGuy', 'Sob', 'Shy', 'Silent', 'Sleep',
    'Cry', 'Awkward', 'Angry', 'Tongue', 'Grin', 'Surprise', 'Frown', 'Ruthless',
    'Blush', 'Scream', 'Puke', 'Chuckle', 'joyful', 'slight', 'smug', '饥饿',
    'drowsy', 'panic', '流汗', 'laugh', '大兵', '奋斗', '咒骂', '疑问',
    '嘘', '晕', '折磨', '衰', '骷髅', '敲打', '再见', '擦汗',
    '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视',
    '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜',
    '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢',
    '示爱', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球',
    '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱',
    '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO',
    'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头',
    '回头', '跳绳', '挥手', '激动', '街舞', '献吻', '左太极', '右太极']

export enum ResCode {
    /**
     * 会话超时
     */
    E10007 = 10007,
    /**
     * 对话超时，需要变化人机、人工的记录标识
     */
    E50001 = 50001,
    /**
     * 转人工标识，意图开启了转人工
     */
    E60001 = 60001,
    /**
     * 5次拒识转人工标识
     */
    E60002 = 60002,
    /**
     * 
     */
    E60003 = 60003,
}

export enum ChatType {
    /**
     * 人机交互方式
     */
    ToRobot = 'ToRobot',
    /**
     * 人人交互方式
     */
    ToHuman = 'ToHuman'
}
